"use client";

import { useEffect, useRef } from "react";

const useTradingViewWidget = (
  src: string,
  config: Record<string, unknown>,
  height = 600,
) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const isAutoSize = config.autoSize === true;
    const styleHeight = isAutoSize ? "100%" : `${height}px`;

    // Clear existing content
    containerRef.current.innerHTML = `<div class="tradingview-widget-container__widget" style="width: 100%; height: ${styleHeight};"></div>`;

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.innerHTML = JSON.stringify(config);

    containerRef.current.appendChild(script);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
    };
  }, [src, config, height]);

  return containerRef;
};

export default useTradingViewWidget;
